const REMEMBER_ME_KEY = "rememberMe";
const REMEMBERED_ID_KEY = "rememberedId";

export function isKeepLoggedInEnabled() {
  try {
    return localStorage.getItem(REMEMBER_ME_KEY) === "true";
  } catch {
    return false;
  }
}

export function getRememberedLoginId() {
  if (!isKeepLoggedInEnabled()) return "";
  try {
    return localStorage.getItem(REMEMBERED_ID_KEY) || "";
  } catch {
    return "";
  }
}

export function setKeepLoggedInPreference(enabled) {
  try {
    localStorage.setItem(REMEMBER_ME_KEY, String(enabled));
    if (!enabled) {
      localStorage.removeItem(REMEMBERED_ID_KEY);
    }
  } catch {
    /* localStorage unavailable */
  }
}

export function persistRememberedLogin(identifier, keepLoggedIn) {
  try {
    localStorage.setItem(REMEMBER_ME_KEY, String(keepLoggedIn));
    if (keepLoggedIn && identifier) {
      localStorage.setItem(REMEMBERED_ID_KEY, identifier);
    } else {
      localStorage.removeItem(REMEMBERED_ID_KEY);
    }
  } catch {
    /* localStorage unavailable */
  }
}
